import { API_VERSION_ESYMANDANT, fetchHandler, HTTP_METHOD, oneLimiter } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiFilestreamResponse } from 'application/api/response_handlers'

export const getCreatorProfilePicture = (accountId, creatorIdHash) => {
    const request = fetchRequestBuilder(API_VERSION_ESYMANDANT + '/e.consult.' + accountId + '/user/' + creatorIdHash + '/profile/picture/other', HTTP_METHOD.GET)

    return oneLimiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiFilestreamResponse)
}